import type { RefObject, VoidFunctionComponent } from 'react';

import { ErrorAlert } from '../../../../generic';
import Drawer from '../../../../generic/Drawer';

import DrawerDescription from './Description';
import DrawerDetails from './Details';
import DrawerHeader from './Header';
import DrawerNVDBaseMetrics from './NVDBaseMetrics';
import DrawerReferences from './References';
import DrawerRemediation from './Remediation';
import type { SelectedVuln } from '../../../../../../shared/organizationPackages/response';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  //  Current version is displayed in the remediation section
  version: string;
  //  Needed to prevent the Drawer from closing when we click a different item in the table.
  tableBodyRef: RefObject<HTMLTableSectionElement>;
  //  Duration of the slide animation.
  slideDuration: number;
 // The locator of the package revision that the drawer is displaying.
  packageRevisionLocator: string;
  selectedVuln?: SelectedVuln;
  error: Error | null;
  isLoading: boolean;
};

/**
 * PackgeVersionVulnerabilityDrawer displays the selectedVuln.
 */
const PackgeVersionVulnerabilityDrawer: VoidFunctionComponent<Props> = ({
  isOpen,
  onClose,
  version,
  tableBodyRef,
  slideDuration,
  packageRevisionLocator,
  selectedVuln,
  error,
  isLoading,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      clickTarget={tableBodyRef}
      slideDuration={slideDuration}
    >
      {error ? (
        <div className="margin-top-lg">
          <ErrorAlert status={{ errors: [error] }} />
        </div>
      ) : (
        <>
          <DrawerHeader
            isLoading={isLoading}
            packageRevisionLocator={packageRevisionLocator}
            selectedVuln={selectedVuln}
          />
          <DrawerRemediation
            isLoading={isLoading}
            packageRevisionLocator={packageRevisionLocator}
            selectedVuln={selectedVuln}
            version={version}
          />
          <DrawerDetails isLoading={isLoading} selectedVuln={selectedVuln} />
          <DrawerDescription isLoading={isLoading} selectedVuln={selectedVuln} />
          <DrawerNVDBaseMetrics isLoading={isLoading} selectedVuln={selectedVuln} />
          <DrawerReferences selectedVuln={selectedVuln} />
        </>
      )}
    </Drawer>
  );
};

export default PackgeVersionVulnerabilityDrawer;
